import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useQuery } from '@tanstack/react-query'
import { ApiKey } from 'features/incidents/components/enums'

export const getPreviousPolicies = async () => {
  return axios.get(endpoints.getPreviousPolicyList)
}

export const useGetPreviousPolicies = () => {
  return useQuery([ApiKey.PreviousPolicies, ApiKey.list], () => getPreviousPolicies())
}
